import BlockIcon from '@mui/icons-material/Block'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material'
import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { CreditApplication } from '../../../data/types'

interface Props {
  open: boolean
  onCancel: () => void
  onSelectApplicant: (applicantType: 'applicant' | 'coApplicant') => void
  hasCoApplicant: boolean
  creditApplication?: CreditApplication
}

const BanApplicantSelectionDialog = ({
  open,
  onCancel,
  onSelectApplicant,
  hasCoApplicant,
  creditApplication,
}: Props) => {
  const { t } = useTranslation()

  const isApplicantBanned =
    creditApplication?.applicant?.creditDecision?.refusalReasonCodes?.includes('Banned') ?? false

  const isCoApplicantBanned =
    creditApplication?.coApplicant?.creditDecision?.refusalReasonCodes?.includes('Banned') ?? false

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle>{t('ban.selectApplicant')}</DialogTitle>
      <DialogContent>
        <Typography variant="body1" gutterBottom>
          {t('ban.selectApplicantMessage')}
        </Typography>
        <Stack spacing={2} sx={{ mt: 2 }}>
          <Button
            variant="outlined"
            color="error"
            startIcon={<BlockIcon />}
            onClick={() => onSelectApplicant('applicant')}
            size="large"
            fullWidth
            disabled={isApplicantBanned}
          >
            {isApplicantBanned ? t('ban.applicantAlreadyBanned') : t('ban.banApplicant')}
          </Button>
          {hasCoApplicant && (
            <Button
              variant="outlined"
              color="error"
              startIcon={<BlockIcon />}
              onClick={() => onSelectApplicant('coApplicant')}
              size="large"
              fullWidth
              disabled={isCoApplicantBanned}
            >
              {isCoApplicantBanned ? t('ban.coApplicantAlreadyBanned') : t('ban.banCoApplicant')}
            </Button>
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>{t('common.cancel')}</Button>
      </DialogActions>
    </Dialog>
  )
}

export default memo(BanApplicantSelectionDialog)
